import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _MaintenanceTypeItem, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { InputMoney } from "../../../theme/Input/InputMoney";

interface Form {
    State: number;
    Location: number;
}

export const MaintenanceTypeItem = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_MaintenanceTypeItem);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [form, setForm] = useState<Partial<Form>>({
        State: 1
    })

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const props = {
            State: form.State,
        }
        instance.getMaintenanceTypeItemCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        setBean({
            State: 1,
        });
        setModal({ ...modal, "name": `Agregar Maquinaria`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };


    const editaItem = (obj: any) => {
        instance.updateMaintenanceTypeItem(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDMaintenanceTypeItem', visible: true },
        { title: 'Tipo de Mantenimiento', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Frecuencia a Realizar (Dias)', property: 'FrecuencyDays', visible: true },
        { title: '¿Requiere parar la Maquina?', property: 'RequiresUnemployment', visible: true },
        { title: 'Costo Estimado', property: 'EstimatedCost', visible: true, mask: MASK_MONEY },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Tipo de Mantenimiento">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Tipo de Mantenimiento</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Frecuencia de Ejecución(Días)</label>
                                <input type="number" className="form-control" value={bean.FrecuencyDays} onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, FrecuencyDays: e.target.value })
                                }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={bean.RequiresUnemployment} eventChange={(e) => { setBean({ ...bean, RequiresUnemployment: e }) }} label="¿Requiere parar la Maquina?" />
                            </div>
                            <div className="col-md-6">
                                <InputMoney _value={bean.EstimatedCost} onChange={(e) => { setBean({ ...bean, EstimatedCost: e }) }} _label="Costo de Mantenimiento" />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}